import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { WifiOff as WifiOffIcon } from '@mui/icons-material';
import useOnlineStatus from '../hooks/useOnlineStatus';

export default function OfflineIndicator() {
  const { isOnline } = useOnlineStatus();

  return (
    <Snackbar
      open={!isOnline}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity="warning"
        icon={<WifiOffIcon />}
        sx={{ width: '100%' }}
      >
        You're offline. Some features may be limited.
      </Alert>
    </Snackbar>
  );
}

